export const trainerExerciseColumns = [
    {
        field: "name",
        headerName: "Exercise Name",
        width: 160,
    },
    {
        field: "type",
        headerName: "Exercise Type",
        width: 160,
    },
    {
        field: "bodyPart",
        headerName: "BodyPart",
        width: 160
    },
    {
        field: "branchName",
        headerName: "Branch Name",
        width: 130,
    },
    {
        field: "branchLocation",
        headerName: "Branch Loc",
        width: 130,
    },
];